import { render } from "./MfTable.vue?vue&type=template&id=0c2bd6b4"
import script from "./MfTable.vue?vue&type=script&lang=js"
export * from "./MfTable.vue?vue&type=script&lang=js"

import "./MfTable.vue?vue&type=style&index=0&id=0c2bd6b4&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__